import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import * as styles from "./TableAllRowSelection.module.css";

interface IProps {
    areAllPageRecordsSelected: boolean;
    areAllRecordsSelected: boolean;
    perPageRecords: number;
    totalRecords: number;
    onSelectAllRecords: () => void;
    onSelectOnlyPageRecords: () => void;
}

export const TableAllRowSelection = (props: IProps) => {
    if ((!props.areAllPageRecordsSelected && !props.areAllRecordsSelected) || props.perPageRecords >= props.totalRecords) {
        return null;
    }

    return (
        <div className={styles.allRowSelection}>
            {props.areAllPageRecordsSelected && !props.areAllRecordsSelected ? (
                <>
                    <Text as="div" variant="body_copy_0" className={styles.inlineBlock}>
                        Zaznaczone są wszystkie rekordy ({props.perPageRecords}) na tej stronie.
                    </Text>
                    <Button variant="outlined_secondary" size="x-small" onClick={props.onSelectAllRecords} className={styles.button}>
                        Zaznacz wszystkie rekordy ({props.totalRecords}) z pozostałych stron.
                    </Button>
                </>
            ) : null}

            {props.areAllRecordsSelected ? (
                <>
                    <Text as="div" variant="body_copy_0" className={styles.inlineBlock}>
                        Zaznaczone są wszystkie rekordy ({props.totalRecords}) z całości wyników wyszukiwania.
                    </Text>
                    <Button variant="outlined_secondary" size="x-small" onClick={props.onSelectOnlyPageRecords} className={styles.button}>
                        Wyczyść zaznaczenie
                    </Button>
                </>
            ) : null}
        </div>
    );
};
import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import * as styles from "./TableAllRowSelection.module.css";

interface IProps {
    areAllPageRecordsSelected: boolean;
    areAllRecordsSelected: boolean;
    perPageRecords: number;
    totalRecords: number;
    onSelectAllRecords: () => void;
    onSelectOnlyPageRecords: () => void;
}

export const TableAllRowSelection = (props: IProps) => {
    if ((!props.areAllPageRecordsSelected && !props.areAllRecordsSelected) || props.perPageRecords >= props.totalRecords) {
        return null;
    }

    return (
        <div className={styles.allRowSelection}>
            {props.areAllPageRecordsSelected && !props.areAllRecordsSelected ? (
                <>
                    <Text as="div" variant="body_copy_0" className={styles.inlineBlock}>
                        Zaznaczone są wszystkie rekordy ({props.perPageRecords}) na tej stronie.
                    </Text>
                    <Button variant="outlined_secondary" size="x-small" onClick={props.onSelectAllRecords} className={styles.button}>
                        Zaznacz wszystkie rekordy ({props.totalRecords}) z pozostałych stron.
                    </Button>
                </>
            ) : null}

            {props.areAllRecordsSelected ? (
                <>
                    <Text as="div" variant="body_copy_0" className={styles.inlineBlock}>
                        Zaznaczone są wszystkie rekordy ({props.totalRecords}) z całości wyników wyszukiwania.
                    </Text>
                    <Button variant="outlined_secondary" size="x-small" onClick={props.onSelectOnlyPageRecords} className={styles.button}>
                        Wyczyść zaznaczenie
                    </Button>
                </>
            ) : null}
        </div>
    );
};
